import React from 'react';
import { Body, Headline, Link } from '@sato/components';
import { observer } from 'mobx-react-lite';

import { IWidget, ParsedEntry } from '@/contentful/types';

import { Link as SatoLink } from '@components/common/Link';
import ServicePartyInfo from '@components/common/ServicePartyInfo';
import { useApartmentProperties } from '@hooks/useApartmentProperties';
import { useCustomTranslations } from '@hooks/useCustomTranslations';
import { useOmaSATOSaunas } from '@hooks/useOmaSATOSaunas';
import { ROUTES } from '@routes/routes.constants';
import { apartmentStore } from '@stores/apartmentStore';

export const SaunaBooking = observer(
  ({ data: { customTranslations } }: { data: ParsedEntry<IWidget> }) => {
    const { t } = useCustomTranslations(customTranslations);
    const { maintenanceCompany } = useApartmentProperties();
    const { saunas } = useOmaSATOSaunas();

    const apartmentsWithSauna = apartmentStore.getApartmentsWithSauna;

    return (
      <div className="flex flex-col gap-3">
        {apartmentsWithSauna?.map((a) => (
          <div className="flex flex-col" key={a.apartmentId}>
            <Headline level={3} className="mb-2 font-bold">
              {t('saunasAt')} {a.address}
            </Headline>

            {(() => {
              const selfReservationSaunas = saunas;

              if (!selfReservationSaunas?.length) {
                return (
                  <>
                    <Body>{t('saunaContactBooking')}</Body>
                    <ServicePartyInfo serviceParty={maintenanceCompany} />
                  </>
                );
              }

              return (
                <div>
                  <Body className="mb-2">{t('saunaOmaSATOBooking')}</Body>

                  {selfReservationSaunas.map((s) => {
                    return (
                      <div key={s.resourceId} className="mb-4">
                        <Link<SatoLink<typeof ROUTES.SAUNA_PAGE>>
                          /* TODO
                           * The Sauna page is still in the older version and will need to be updated in a later date.
                           */
                          wrapperComponent={SatoLink}
                          to={ROUTES.SAUNA_PAGE}
                        >
                          {s.name}
                        </Link>
                      </div>
                    );
                  })}
                </div>
              );
            })()}
          </div>
        ))}
      </div>
    );
  }
);
